// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "8f7c6db42a4c0f0cb655" + ".chunk.js";
};